module.exports = __webpack_public_path__ + "static/jagannath-65382371885b9023c80bca55c0047982.jpg";